<script>
import axios from 'axios';
export default {
  props: ['commentBox', 'submitCommentButtonText'],
  data() {
    return {
      Pheading: this.commentBox.heading,
      PbuttonText: this.submitCommentButtonText,
      from: this.commentBox.from || '',
      comment: '',
      seen: true,
      externalusername: '',
      externalemail: '',
    };
  },
  async created() {
    await import(
      /* webpackChunkName: "recaptcha" */ '../../../static/js/loaders/recaptcha.js'
    );
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/forms.js'
    );
  },
  mounted() {
    // OBS ger error i fractal och komponenten fungerar inte som den ska (i fractal)
    grecaptcha.ready(function () {
      grecaptcha
        .execute('6LcO3mgaAAAAAOD3_YJR8v8_ziWj3JWCTf1HCVy9', {
          action: 'submit',
        })
        .then(function (token) {
          console.log('token', token);
        });
    });
  },
  methods: {
    postComment() {
      this.seen = !this.seen;
      let data = {
        pageid: this.commentBox.pageid,
        comment: this.comment,
        auth: this.commentBox.auth,
        from:
          this.commentBox.auth == 'True'
            ? this.commentBox.from
            : this.externalusername,
        email:
          this.commentBox.auth == 'True'
            ? this.commentBox.email
            : this.externalemail,
      };
      axios
        .post(this.commentBox.url, data)
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <div v-if="seen" id="hide">
      <div class="form-group">
        <label>{{ Pheading }}</label>
        <div class="comment-input">
          <input
            type="text"
            v-if="from == ''"
            class="form-control"
            v-model="externalusername"
            placeholder="Namn" />
          <input
            type="text"
            v-if="from == ''"
            class="form-control mt-2"
            v-model="externalemail"
            placeholder="E-post" />
          <textarea
            class="form-control mt-2"
            v-model="comment"
            rows="2"
            placeholder="Kommentar"></textarea>
        </div>
      </div>
      <div v-if="from != ''">
        <button
          @click="postComment"
          v-if="comment == ''"
          disabled
          id="comment-submit"
          name="submit"
          class="button-default">
          {{ PbuttonText }}
        </button>
        <button
          @click="postComment"
          v-else
          id="comment-submit"
          name="submit"
          class="button-default">
          {{ PbuttonText }}
        </button>
      </div>
      <div v-else>
        <button
          v-if="
            comment === '' || externalusername === '' || externalemail === ''
          "
          @click="postComment"
          disabled
          id="comment-submit"
          name="submit"
          class="button-default">
          {{ PbuttonText }}
        </button>
        <button
          v-else
          @click="postComment"
          id="comment-submit"
          name="submit"
          class="button-default">
          {{ PbuttonText }}
        </button>
      </div>
    </div>
    <div class="sent-message" v-if="!seen">
      <div v-if="from == ''">
        <h4>
          Tack för din kommentar! Så fort den granskats kommer den bli synlig
        </h4>
      </div>
      <div v-else>
        <h4>Tack för din kommentar! Ladda om sidan för att se den</h4>
      </div>
    </div>
  </div>
</template>
